import type { ExportPageLayout } from '../types/export';

export const exportPageFormats = [
  { key: 'a4', label: 'A4 · 210 × 297 mm', widthMm: 210, heightMm: 297 },
  { key: 'a5', label: 'A5 · 148 × 210 mm', widthMm: 148, heightMm: 210 },
  { key: 'b6', label: 'B6 · 125 × 176 mm', widthMm: 125, heightMm: 176 },
  { key: 'pocket', label: 'Taschenbuch · 120 × 190 mm', widthMm: 120, heightMm: 190 },
  { key: 'paperback', label: 'Taschenbuch · 140 × 210 mm', widthMm: 140, heightMm: 210 },
  { key: 'trade', label: 'Taschenbuch · 152,4 × 228,6 mm (6 × 9 Zoll)', widthMm: 152.4, heightMm: 228.6 }
] as const;

export function defaultExportPageLayout(): ExportPageLayout {
  return { widthMm: 210, heightMm: 297, marginsMm: { top: 20, right: 20, bottom: 20, left: 20 } };
}
export function exportPageLayoutError(layout: ExportPageLayout) {
  const { widthMm, heightMm, marginsMm: margins } = layout;
  if (![widthMm, heightMm, ...Object.values(margins)].every(Number.isFinite))
    return 'Bitte gib alle Maße und Ränder als Zahlen in Millimetern ein.';
  if (widthMm < 80 || widthMm > 600 || heightMm < 80 || heightMm > 600)
    return 'Breite und Höhe müssen zwischen 80 und 600 mm liegen.';
  if (Object.values(margins).some((margin) => margin < 0 || margin > 600))
    return 'Die Seitenränder müssen zwischen 0 und 600 mm liegen.';
  if (widthMm - margins.left - margins.right < 40 || heightMm - margins.top - margins.bottom < 60)
    return 'Die Ränder lassen zu wenig Platz: Für den Text müssen mindestens 40 mm Breite und 60 mm Höhe bleiben.';
  return '';
}
